/**
 * 过滤器
 */
import config from './config'

export default {
    // 时间转换
    formatTime: function (timestamp) {
        if (!timestamp) {
            return ''
        }
        var times = new Date(timestamp);
        var nowTime = new Date(Date.now());
        var sizeTime = (nowTime.getTime() - times.getTime()) / 1000;
        var toTen = function (num) {
            return num < 10 ? '0' + num : num;
        }
        var year = times.getFullYear();
        var month = toTen(times.getMonth() + 1);
        var date = toTen(times.getDate());
        var minute = toTen(times.getMinutes());
        var hour = toTen(times.getHours());
        var nowYear = nowTime.getFullYear();
        // 大于24小时，小于一年
        if (3600 * 24 < sizeTime && sizeTime < 3600 * 24 * 30 * 12) {
            //不同年份
            if (year !== nowYear) {
                return year + '年' + month + '月' + date + '日';
                //相同年份
            } else {
                return month + '月' + date + '日';
            }
        } else if (sizeTime <= 3600 * 24) { // 小于24小时
            //大于等于1小时    
            if (sizeTime >= 3600) {
                return parseInt(sizeTime / 3600) + '小时前';
                //大于一分钟
            } else if (sizeTime > 60) {
                return parseInt(sizeTime / 60) + '分钟前';
                //小于等于一分钟
            } else {
                return '刚刚';
            }
        } else {
            return year + '年' + month + '月' + date + '日';
        }
    },
    formatTime_YMD: function (timestamp) {
        if (!timestamp) {
            return ''
        }
        var times = new Date(timestamp);
        var toTen = function (num) {
            return num < 10 ? '0' + num : num;
        }
        var year = times.getFullYear();
        var month = toTen(times.getMonth() + 1);
        var date = toTen(times.getDate());
        return year + '-' + month + '-' + date;
    },
    formatPublishTime(timestamp) {
        if (!timestamp) {
            return ''
        }
        var times = new Date(timestamp);
        var toTen = function (num) {
            return num < 10 ? '0' + num : num;
        }
        var year = times.getFullYear();
        var month = toTen(times.getMonth() + 1);
        var date = toTen(times.getDate());
        var minute = toTen(times.getMinutes());
        var hour = toTen(times.getHours());
        return year + '-' + month + '-' + date + ' ' + hour + ':' + minute;

    },
    //个位数转为十位数
    toTen: function (num) {
        return num < 10 ? '0' + num : num;
    },
    // 来源
    sourceReset: function (source) {
        return source || 'TY'
    },
    linkFilter(item) {
        console.log(item, this)
        return this.formatTime(item);
    },
    textOverflow(text) {
        if (text && text.length > 6) {
            return text.substr(0, 6) + '...'
        }
        return text
    },

    newsKind(item) {
        if (item.isSubjectEntrance) {
            return '专题'
        }
        if (item.extKind == 2) {
            return '活动'
        }
        return ''
    },
    resetNum: function (value) {
        if (!value || value < 0) {
            return 0;
        }
        var value = parseInt(value);
        return value >= 100000000 ? parseFloat((parseInt(value * 10 / 100000000) / 10).toFixed(1)) + '亿' : value >= 10000 ? parseFloat((parseInt(value * 10 / 10000) / 10).toFixed(1)) + '万' : value;
    },
    videoDuration(time) {
        if (!time) {
            return '00:00';
        }
        var time = parseInt(time);
        return time >= 60 ? Math.floor(time / 60) < 10 ? '0' + Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : (time < 10 ? '00:0' + time : '00:' + time);
    },
    // label 1：专题，2：热点，3：图集，4：视频， 6:直播中， 7：直播回顾， 8：VR，9:活动， 10：广告， 11：本地， 12：置顶， 13：专栏， 14：精选，15：独家 16: 直播预告 17:原创

    labelTxtFilter(label) {
        return [
            "",
            "专题",
            "",
            "",
            "",
            "",
            "直播中",
            "直播回放",
            "",
            "",
            "",
            "",
            "",
            "专栏",
            "",
            "",
            "直播预告",
            ""
        ][label];
    },
    pc_routeFilter(item, type = 'list') { // type: list：频道, news：新闻详情
        if (type === 'list') {
            if (item.isNewsWebHomePage) {
                return '/pc/home'
            } else {
                return '/pc/list/' + item.type + '/' + item.channel_id
            }
        }
        if (type === 'news') {
            var type = parseInt(item.flag);
            var id = item.news_id;
            if (type === 10 || type === 14 || type == 55 || type == 56 || type == 57 || type == 58) { // 外链 外链活动 慧度直播相关
                return item.external_url;
            } else if (type === 3) { // 图集
                return '/pc/atlasDetails/' + id;
            } else if (type === 4 || type === 11 || type === 40 || type === 42) { // 视频
                return '/pc/videoNews/' + id;
            } else if (type === 7 || type === 9 || type === 19 || type === 21 || type === 2101 || type === 22 || type === 24 || type == 901 || type == 2401 || type === 25 || type === 2501 || type === 27) { // 常规直播 竖直播 直播预告
                //直播页面 先用iframe嵌套wap页面
                const formalEnv = location.host.indexOf('cannews.com.cn') > -1 || location.host.indexOf('hkqg.hangkong.com.cn') > -1
                let targetUrl = formalEnv ? 'https://wap.hangkong.com.cn' : 'https://test-wap.hangkong.com.cn'
                if (type === 7 || type === 9 || type === 19 || type === 21 || type === 2101 || type === 22 || type === 24) {
                    targetUrl += '/live_casting.html?news_id=' + id + '&version=new&from=web'
                } else if (type === 25 || type === 2501 || type === 27) {
                    targetUrl += '/live_forecast.html?news_id=' + id + '&version=new&from=web'
                } else if (type == 901 || type == 2401) {
                    targetUrl += '/new_live_casting.html?news_id=' + id + '&version=new&from=web'
                }
                return '/pc/liveNews/' + id + '?targetUrl=' + encodeURIComponent(targetUrl);
            } else if (type === 5 || type === 13) { // 无分类专题专栏
                return '/pc/subject/' + item.subject_id + '/' + type;
            } else if (type === 30 || type === 36) { // 有分类专题专栏
                return '/pc/subject/' + item.subject_id + '/' + type;
            } else { //普通新闻
                return '/pc/news/' + id;
            }
        }
    },
}